import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("dashboard");

const urls = {
  fetchQueryTypes: `/merchant/analytics/query-type`,
  fetchChart: `/merchant/analytics/chart`,
};

const initState = () => {
  return {
    queryTypes: [],
    chart: {},
  };
};

const actions = {
  fetchQueryTypes: async ({ commit }) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.fetchQueryTypes);
      commit("saveQueryTypes", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchChart: async ({ commit }, request) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.post(urls.fetchChart, request);
      commit("saveChart", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveQueryTypes: (state, data) => {
    Vue.set(state, "queryTypes", data);
  },
  saveChart: (state, data) => {
    Vue.set(state, "chart", data);
  },
};

const getters = {
  getQueryTypes: (state) => {
    return state.queryTypes;
  },
  getChart: (state) => {
    return state.chart;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
